/* eslint-disable no-console */

import React, { Component, Fragment } from 'react';
import smoothscroll from 'smoothscroll-polyfill';
import setBrowserTitle from '../../js/utils/setBrowserTitle';
import Nbccta from '../nbc-cta';
import VideoHero from '../video-hero';
import VideoHub from '../video-hub';
import Devices from '../fast/fast-devices';
import FastSchedule from '../fast/fast-schedule';
import { VideoPageProps, VideoPageState } from './videoHubTypes';

const {
  wp: {
    i18n: {
      __,
    },
  },
  nbc: {
    globalSiteKey = '',
  },
} = window;

export default class VideoPage extends Component<VideoPageProps, VideoPageState> {
  tabs: string[] = [];

  static defaultProps = {
    categories: [],
    categoryName: '',
    ctalogo: '',
    fastEnabled: false,
    fastEyebrow: '',
    fastLogos: [],
    fastData: [],
    fromLive: false,
    initialCategoryPosts: [],
    initialCategoryPages: 1,
    nextUpSource: '',
    replaceStateOnLoad: false,
    showSearch: true,
    showvideo: true,
    showVideoHub: true,
    tvSchedule: false,
    videos: [],
  };

  constructor(props) {
    super(props);

    const {
      videos: [activeVideo, nextVideo],
      showvideo,
    } = props;

    this.state = {
      activeVideo: showvideo ? activeVideo || {} : {},
      nextVideo: { ...nextVideo, videoIndex: 1 },
      videos: props.videos,
      categoryVideos: props.initialCategoryPosts || [],
      nextVideoTriggered: 'first',
      activeVideoIndex: 0,
      fastHeroTitle: '',
      fastHeroDek: '',
    };

    // Live TV tab for stations only.
    const liveTV = ! globalSiteKey.toLowerCase().includes('rsn') ? [__('Live TV', 'nbc')] : [];
    // Remove news tab if tv schedule page.
    const tabGroup = [__('News', 'nbc'), ...props.fastEnabled ? [] : [liveTV]];
    if (props.tvSchedule) {
      tabGroup.splice(0, 1);
    }
    this.tabs = tabGroup;
  }

  componentDidMount() {
    const { replaceStateOnLoad } = this.props;

    if (replaceStateOnLoad) {
      const { activeVideo } = this.state;
      this.setActiveVideo(activeVideo);
    }
  }

  /**
   * Set the next video.
   *
   * @param {Number} index The next video index.
   */
  setNextVideo = () => {
    const {
      videos,
      activeVideoIndex,
    } = this.state;

    const nextVideo = videos[activeVideoIndex + 1] || videos[0];

    this.setActiveVideo(nextVideo);

    this.setState({
      nextVideoTriggered: 'continuous',
    });
  };

  /**
   * Set the active/playing video.
   *
   * @param {Object} video The video object.
   */
  setActiveVideo = (video) => {
    const {
      videos,
    } = this.state;

    const activeIndex = videos.findIndex((vid) =>
      vid.network_object_id === video.network_object_id);

    const nextVideoIndex = videos[activeIndex + 1] ? activeIndex + 1 : 0;

    this.setState(
      {
        activeVideoIndex: activeIndex,
        activeVideo: video,
        nextVideo: { ...videos[nextVideoIndex], videoIndex: nextVideoIndex },
        nextVideoTriggered: 'carousel',
      },
      () => {
        const {
          title: activeTitle,
          link,
        } = video;

        // if template-hero isn't on a whitelabel site, fallback to section-content--primary.
        const scrollToElement = document.getElementsByClassName('template-hero')[0] || document.getElementsByClassName('section-content--primary')[0];

        // Set the browser URL.
        // phpcs:ignoreFile WordPressVIPMinimum.JS.Window.location
        if (
          window.history
          && window.history.replaceState
          && link !== window.location.href
        ) {
          window.history.replaceState({}, activeTitle, link);
          setBrowserTitle(activeTitle);
        }
        // scroll to player.
        smoothscroll.polyfill();
        scrollToElement.scrollIntoView({ behavior: 'smooth' }); // eslint-disable-line max-len
      }
    );
  };

  setFastHedDek = ({
    fastHeroTitle,
    fastHeroDek,
  }) => {
    this.setState({
      fastHeroTitle,
      fastHeroDek,
    });
  };

  render() {
    const {
      props: {
        nextUpSource = '',
        categories = [],
        ctalogo = '',
        showvideo = true,
        categoryName = '',
        showSearch = true,
        initialCategoryBase,
        initialCategoryPages = 1,
        fromLive = false,
        showVideoHub = true,
        accountId = '',
        siteHost = '',
        twitterVia = '',
        callLetters = '',
        station = '',
        brand = '',
        fastEnabled = false,
        fastEyebrow = '',
        fastLogos = [],
        fastData = [],
        tvSchedule = false,
      },
      state: {
        activeVideo,
        nextVideo,
        videos,
        categoryVideos,
        nextVideoTriggered,
        fastHeroTitle,
        fastHeroDek,
      }, //
    } = this;

    return (
      <Fragment>
        { ! showvideo && ! tvSchedule &&
          <Nbccta ctalogo={ctalogo} />
        }
        { videos && showvideo &&
          <VideoHero
            activeVideo={activeVideo}
            setActiveVideo={this.setActiveVideo}
            setNextVideo={this.setNextVideo}
            nextVideo={nextVideo}
            nextUpSource={nextUpSource}
            videos={videos}
            categoryName={categoryName}
            fromLive={fromLive}
            accountId={accountId}
            siteHost={siteHost}
            twitterVia={twitterVia}
            nextVideoTriggered={nextVideoTriggered}
            callLetters={callLetters}
            station={station}
            brand={brand}
            fastEnabled={fastEnabled}
            fastEyebrow={fastEyebrow}
            fastHeroTitle={fastHeroTitle}
            fastHeroDek={fastHeroDek}
            fastSchedule={fastData}
          />
        }
        { fastEnabled &&
        <div className="fast-components">
          { 0 < fastData.length &&
            <FastSchedule
              fastSchedule={fastData}
              setFastMeta={this.setFastHedDek}
            />
          }
          {fastLogos &&
          <Devices
            fastLogos={fastLogos}
          />
          }
        </div>
        }
        { showVideoHub &&
          <VideoHub
            categoryMenuItems={categories}
            initialCategoryVideos={categoryVideos}
            setActiveVideo={false}
            topLevelMenuItems={this.tabs}
            showSearch={showSearch}
            initialCategoryBase={initialCategoryBase}
            initialCategoryPages={initialCategoryPages}
            tvSchedule={tvSchedule}
          />
        }
      </Fragment>
    );
  }
}
